import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-third-party-info',
  templateUrl: './text-third-party-info.component.html',
  styleUrls: ['./text-third-party-info.component.css'],
})
export class TextThirdPartyInfoComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit() {
  }

}
